import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCol,
  IonRow,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonGrid,
  useIonViewDidEnter,
} from "@ionic/react";
import { useParams } from "react-router";
import ExploreContainer from "../components/ExploreContainer";
import { Descriptions, Row, Col, notification, Table, Tag } from "antd";
import { Card } from "antd";
import { Switch } from "antd";
import { Input } from "antd";
import moment from "moment";
import { PageHeader } from "antd";
import "./Page2.css";
import { DatePicker, Space } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  DataGrid,
  GridApi,
  GridCellParams,
  GridToolbar,
} from "@mui/x-data-grid";
import { useDemoData } from "@mui/x-data-grid-generator";
import Button from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { createStyles, makeStyles, Theme } from "@mui/material/styles";

import { UIStore } from "../store/store";

const Property: React.FC = (props: any) => {
  //fetching from store(PullState)
  const currentProperty = UIStore.useState((s) => s.SelectedProperty);

  const [data1, SetData] = useState([]);
  const [open, setOpen] = useState(true);

  const { name } = useParams<{ name: string }>();

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      backdrop: {
        background: "black",
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
      },
    })
  );
  const classes = useStyles();

  const columns = [
    { field: "id", headerName: "ID", width: 120 },
    { field: "created", headerName: "DATE CREATED", width: 190 },
    { field: "Name", headerName: "NAME", width: 170 },
    { field: "MonthlyRent", headerName: "RENT", width: 120 },
    { field: "Address", headerName: "ADDRESS", width: 370 },
    { field: "numberofrooms", headerName: "ROOM", width: 130 },
    { field: "Description", headerName: "DESCRIPTION", width: 170 },
    { field: "PropertyType", headerName: "TYPE", width: 170 },
    { field: "PropertyUses", headerName: "USAGE", width: 170 },
    { field: "FurnishedType", headerName: "FURNISHING", width: 170 },
    {
      field: "details",
      headerName: "DETAILS",
      width: 190,
      renderCell: (params: any) => {
        return (
          <strong>
            <Link to={{ pathname: "/PropertyDetails" }}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => {
                  //updating the store(PullState) Property value
                  UIStore.update((s, o) => {
                    s.SelectedProperty = params.row;
                  });
                }}
                style={{ marginLeft: 25 }}
              >
                {" "}
                View Details{" "}
              </Button>
            </Link>
          </strong>
        );
      },
    },
  ];
  const handleBackDropClose = () => {
    setOpen(false);
  };

  useIonViewDidEnter(() => {
    axios
      .get("https://dev.northroom.co.za/api/bizprop/properties/all")
      .then(function (response) {
        // handle success
        SetData(response.data);
        handleBackDropClose();
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
      });
  });

  return (
    <IonPage>
      <Backdrop
        className={classes.backdrop}
        open={open}
        transitionDuration={1500}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader className="site-page-header" title="Property" />
          </IonRow>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="11" style={{ paddingLeft: "2vw", paddingRight: "5vw" }}>
                <IonCard>
                  <IonCardHeader></IonCardHeader>
                  <IonCardContent>
                    <div
                      style={{
                        height: 400,
                        width: "80vw",
                        paddingRight: "7.5vw",
                      }}
                    >
                      <DataGrid
                        rows={data1}
                        columns={columns}
                        components={{
                          Toolbar: GridToolbar,
                        }}
                        filterModel={{
                          items: [
                            {
                              columnField: "Name",
                              operatorValue: "contains",
                              value: "",
                            },
                          ],
                        }}
                      />
                    </div>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </Space>
      </IonContent>
    </IonPage>
  );
};

export default Property;
